import { UniqueId } from "../../../../utilities";

/**
 * @mixin
 */
export default {
	inheritAttrs: false,

	props: {
		/**
		 * Enter a unique id for the input element.
		 */
		id: {
			type: String,
			default: () => new UniqueId("input-").generate()
		},

		/**
		 * Set to `true` to disable the input.
		 */
		isDisabled: {
			type: Boolean,
			default: false
		},

		/**
		 * Set to `true` to put the component into error state.
		 */
		isError: {
			type: Boolean,
			default: false
		},

		/**
		 * The initial value. **Vue.js users should use `v-model` with a data property in your app instead of this prop directly.**
		 */
		value: {
			type: String
		},

		/**
		 * The text string for the label element.
		 */
		label: {
			type: String,
			required: true
		},

		/**
		 * Add custom classes to the input.
		 */
		customInputClasses: {
			type: String | Object | Array
		},

		/**
		 * An array of validation error messages. `['This field is required!', 'No special characters!']`
		 */
		validationErrors: {
			type: Array,
			default: () => []
		},

		/**
		 * If you wish to set a fixed height for the validation errors container (to avoid the contents of the page moving farther down the page when validation errors appear), set a min-height pixel value (for example `100px`).
		 */
		validationFixedHeight: {
			type: String,
			required: false,
			default: null
		},

		/**
		 * A Vuelidate validation object. See validation example above.
		 */
		vuelidateItem: {
			type: Object
		},

		/**
		 * A mapping of Vuelidate rules to error messages. See validation example above.
		 */
		vuelidateRules: {
			type: Object
		},

		theme: {
			type: String
		}
	},

	computed: {
		error() {
			if (this.vuelidateItem) {
				return this.vuelidateItem.$error && this.vuelidateItem.$dirty;
			}

			return this.isError;
		},

		errorMessages() {
			if (this.vuelidateRules) {
				return this.vuelidateErrors;
			}

			return this.validationErrors;
		},

		vuelidateErrors() {
			return Object.keys(this.vuelidateRules)
				.filter((rule) => {
					return !this.vuelidateItem[rule];
				})
				.map((rule) => {
					return this.vuelidateRules[rule];
				});
		}
	}
};
